import { importProvidersFrom } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateService } from '@ngx-translate/core';
import { NgxMatPaginatorIntl } from '../_providers/ngxmatpaginatorintl';

export const materialProviders = [
  importProvidersFrom(
    MatTooltipModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
  ),
  {
    provide: MatPaginatorIntl,
    useFactory: (translate: TranslateService) => {
      const service = new NgxMatPaginatorIntl();
      service.injectTranslateService(translate);
      return service;
    },
    deps: [TranslateService],
  },
];
